module.exports = __webpack_public_path__ + "img/06_dead.726f5ce4.png";